export default "__VITE_ASSET__ByvyNrJW__"